// Module
var code = "<div class=\"block-5__image image\"></div> ";
// Exports
export default code;